export enum COMPANY_STEP_FORMS {
    BASIC_INFORMATION = 'Basic Information',
    OTHER_INFORMATION = 'Other Information',
    CONTACT_INFORMATION = 'Contact Information',
    CONFIRMATION = 'Confirmation',
}